import React from 'react';
export function IdentidadSection() {
  return <section className="bg-[#FFFFFF] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-71">
      <div className="max-w-5xl mx-auto flex flex-col items-center space-y-16" data-id="element-72">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F0F0F] text-center" data-id="element-73">
          Hay dos tipos de vendedores
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full" data-id="element-74">
          {/* Left Column */}
          <div className="flex flex-col items-center text-center space-y-6 p-8 rounded-3xl border border-[#0F0F0F]/10 bg-[#FFFFFF]" data-id="element-75">
            <ul className="space-y-6 text-xl md:text-2xl text-[#0F0F0F] opacity-70 font-medium" data-id="element-76">
              <li data-id="element-77">Trabajan todo el día</li>
              <li data-id="element-78">Agenda llena</li>
              <li data-id="element-79">Siempre ocupados</li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="flex flex-col items-center text-center space-y-6 p-8 rounded-3xl border-2 border-[#C9A96E] bg-[#FFFFFF] shadow-lg" data-id="element-80">
            <ul className="space-y-6 text-xl md:text-2xl text-[#0F0F0F] font-bold" data-id="element-81">
              <li data-id="element-82">Venden como negocio</li>
              <li data-id="element-83">Diseñan su agenda</li>
              <li data-id="element-84">Protegen su tiempo</li>
              <li className="text-[#C9A96E]" data-id="element-85">Crean crecimiento</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 text-center" data-id="element-86">
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0F0F0F] leading-tight" data-id="element-87">
            Quienes venden como negocio
            <br data-id="element-88" />
            diseñan su nivel de juego.
          </p>
        </div>
      </div>
    </section>;
}